// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"778":"76b51954","789":"c6150c98","897":"8fb4aac3"}[chunkId] + ".chunk.css";
};